import get from "lodash/get";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { func, object } from "prop-types";
import { AccessType } from "@quintype/components";
import AccountModal from "../../login/AccountModal";
import { GroupsAndPlansModal, LoginModal, CheckoutModal } from "./Modals";

import "./subscription-page.m.css";

const SubscriptionLayout = ({ initAccessType, initPaytrailPayment, getSubscription, validateCoupon, member }) => {
  const [activeTab, setActiveTab] = useState("subscription");
  const [selectedPlan, setSelectedPlan] = useState({});
  const [selectedSubscriptionGroup, setSelectedSubscriptionGroup] = useState({});
  const [isCheckoutInitialized, setIsCheckoutInitialized] = useState(false);

  useEffect(() => {
    !global.AccessType && initAccessType();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const defaultSubscriptionGroup = queryParams.get('group');

    if (member && defaultSubscriptionGroup) {
      getSubscription().then((res) => {
        const defaultSelectedOptions = {};

        res.forEach((group, id) => {
          const firstPlan = get(group, ["subscription_plans", "0"]);
          defaultSelectedOptions[group.name] = firstPlan;
        });

        const selectedPlanConfig = defaultSelectedOptions[defaultSubscriptionGroup];
        setActiveTab("checkout");
        setSelectedSubscriptionGroup(defaultSubscriptionGroup);
        setSelectedPlan({ plan: selectedPlanConfig });
        setIsCheckoutInitialized(true);
      });
    }
  }, [member]);

  useEffect(() => {
      if (activeTab === "checkout" || activeTab === "login") {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 0);
      }
  }, [activeTab]);

  switch (activeTab) {
    case "subscription":
      return (
        <GroupsAndPlansModal
          member={member}
          setActiveTab={setActiveTab}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          getSubscription={getSubscription}
          setSelectedSubscriptionGroup={setSelectedSubscriptionGroup}
          setIsCheckoutInitialized={setIsCheckoutInitialized}
        />
      );

    case "login":
      return <LoginModal
              setActiveTab={setActiveTab}
              AccountModal={AccountModal}
              selectedPlan={selectedPlan}
              selectedSubscriptionGroup={selectedSubscriptionGroup}
            />;

    case "checkout":
      return (
        <>
          {isCheckoutInitialized && (
            <CheckoutModal
              member={member}
              setActiveTab={setActiveTab}
              initPaytrailPayment={initPaytrailPayment}
              selectedPlan={selectedPlan}
              validateCoupon={validateCoupon}
              selectedSubscriptionGroup={selectedSubscriptionGroup}
            />
          )}
        </>
      );

    default:
      return <GroupsAndPlansModal
              member={member}
              setActiveTab={setActiveTab}
              getSubscription={getSubscription}
              setSelectedSubscriptionGroup={setSelectedSubscriptionGroup}
              setIsCheckoutInitialized={setIsCheckoutInitialized}
            />;
  }
};

SubscriptionLayout.propTypes = {
  initAccessType: func,
  initPaytrailPayment: func,
  getSubscription: func,
  validateCoupon: func,
  member: object,
};

export const SubscriptionPage = () => {
  const member = useSelector((state) => get(state, ["member"], null));

 /* const member= {
    "id": 2002282,
    "name": "Khemraj",
    "email": "khem.neupane@fiare.com",
    "created-at": 1729084185495,
    "avatar-url": null,
    "first-name": null,
    "last-name": null,
    "verification-status": "social-google",
    "metadata": null,
    "avatar-s3-key": null,
    "slug": null,
    "communication-email": null,
    "phone-number": null,
    "updated-at": 1737705031051,
    "is-tfa-enabled": false,
    "verified-mediums": [
        "email",
        "social-google"
    ],
    "login-phone-number": null,
    "username": "khem.neupane@fiare.com"
  }*/

  const email = get(member, ["email"], "");
  const phone = get(member, ["metadata", "phone-number"], "");
  const { key, accessTypeBkIntegrationId, ATBaseUrl } = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "accesstypeConfig"], {})
  );

  return (
    <>
      <AccessType
        enableAccesstype={true}
        accessTypeKey={key}
        email={email}
        phone={phone}
        prodHost={ATBaseUrl}
        stagingHost={ATBaseUrl}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
      >
        {({ initAccessType, validateCoupon, initPaytrailPayment, getSubscription }) => (
          <SubscriptionLayout
            initAccessType={initAccessType}
            initPaytrailPayment={initPaytrailPayment}
            getSubscription={getSubscription}
            validateCoupon={validateCoupon}
            member={member}
          />
        )}
      </AccessType>
    </>
  );
};
